import { gql } from '@apollo/client';

export const GET_CAMPAIGN_MESSAGES = gql`
  query GetCampaignMessages($campaignId: Int!) {
    campaignMessages(
      where: { campaignId: { eq: $campaignId } }
      order: { createdDate: DESC }
    ) {
      id
      message
      attachmentUrl
      createdDate
      messageRead
      readDate
      campaignId
      senderId
      senderUserName
      senderType
      senderTypeNavigation {
        id
        typeName
      }
      messageTypeId
      messageType {
        id
        typeName
      }
    }
  }
`;

